import { CreateObject, PostBase, PostObjectResponse } from "./metadata";

export class User {
    email!: string;
    unixID!: string;
    roleID?: 1 | 2 | 3 | 4;
    role!: 'View Only' | 'Editor' | 'Admin' | 'System Admin';
    picture?: string;
    displayName!: string;
    givenName!: string;
    isViewer!: boolean;
    initials?: string;
  }

export class UserRaw extends CreateObject{
  email!: string;
  unixID?: string;
  roleID?: 1 | 2 | 3 | 4;
  
  get abstractDate(): string {
    return new Date().toISOString().split("T")[0]
  }
  
  get abstractID(): string | undefined {
    return this.unixID!
  }
  
  toPost(changes: UserRaw): UserRawPost {
    return new UserRawPost(this, changes);
  }

  static override parseFromPostResponse(post: UserRawPostResponse): UserRawPostResponse{
    post.updatedData = Object.assign(new User(), post.updatedData);
    return post
  }
}
export interface UserRawEndpointResponse {
  users: Array<UserRaw>
}

export class UserRawPost extends PostBase{
  email: typeof UserRaw.prototype.email
  unixID: typeof UserRaw.prototype.unixID
  roleID: typeof UserRaw.prototype.roleID

  constructor(source: UserRaw, newValue: UserRaw) {
    super(source, newValue);

    if(newValue.unixID && source.unixID && source.unixID !== newValue.unixID){
      throw Error("UserRawPost: unixID cannot be overwritten");
    }

    this.unixID = source.unixID;
    this.email = newValue.email;
    this.roleID = newValue.roleID;
  }
  
  getSourceWrapper(): { (post: UserRawPostResponse): UserRawPostResponse } {
    return UserRaw.parseFromPostResponse
  }
}

export type UserRawPostResponse = PostObjectResponse<UserRaw>

export class UserCreate{
  email!: string;
  roleID!: 1 | 2 | 3 | 4;
}

export class UserCreateResponse{
  success!: boolean
  updatedData!: UserCreate | undefined
}